import { useMemo } from 'react';
import GreenTick from '../../components/GreenTick';
import { useCosmos } from '../../helpers/cosmosHelper';
import { useTaskHelper } from '../../helpers/taskHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import utils from '../../utils';
import img from '../Idn_arrow.svg';
import lockIcon from '../lock.svg';
import { useEvent } from '../events/event/EventProvider';
import './ActionBadge.scss';

const ActionBadge = ({ badge }) => {
  const [{ user }] = useGlobalState();
    const [{ nftProfile }] = useEvent();
  const [{ userIdentity }] = useGlobalState();
  const [{ isLoggedIn }] = useCosmos();
  const taskHelper = useTaskHelper();
  const { onVerify, onAction } = useMemo(
    () => ({
      onVerify: async task => {
        if (!task) return;
        try {
          await taskHelper.verify(task);
        } catch (e) {
          console.error('Verification error:', e);
        }
      },
      onAction: () => {
        taskHelper.action(badge);
        console.log({ badge });
      },
    }),
    [taskHelper, badge],
  );
  return (
    <div className='action_badge '>
      <div className='badge_info'>
        <div className='nft_preview_border'>
          <img src={badge.badge_img} alt='badge' className='badge_img' />
          {!userIdentity?.claims?.[utils.bsonIdToBytes12(badge?.id)] && (
            <div className='lock-overlay'>
              <img src={lockIcon} alt='Locked' className='lock-icon' />
            </div>
          )}
        </div>
        <div className='desc'>
          <div className='badge_title'>{badge.name}</div>
          <div className='badge_desc'>
            {badge.description}{' '}
            {badge.type === 'MultiAccountAuthenticators' && (
              <a
                href='https://burntlabs.notion.site/How-to-add-Authenticator-for-XION-Meta-Account-1cbcfdc5d6bc80df9bb1e0fd6160d58e?pvs=4'
                target='_blank'
                rel='noopener noreferrer'
              >
                How to add authenticator?
              </a>
            )}
          </div>
        </div>
      </div>
      {user && nftProfile ? (
        userIdentity?.claims?.[utils.bsonIdToBytes12(badge?.id)] ? (
          <GreenTick />
        ) : (
          <div className='action_btn'>
            <div
              className='verify'
              onClick={() =>
                isLoggedIn(() => {
                  onVerify(badge);
                })
              }
            >
              Verify
              <span className='arrow'>
                <img src={img} alt='arrow'></img>
              </span>
            </div>

            <button
              className='goto_action'
              onClick={() =>
                isLoggedIn(() => {
                  onAction();
                })
              }
            >
              GO TO ACTION
            </button>
          </div>
        )
      ) : (
        <div className='login-badge' onClick={() => isLoggedIn(() => {})}>
          <span>Login with Xion</span>
        </div>
      )}
    </div>
  );
};

export default ActionBadge;
